import { useEffect, useRef, useCallback } from "react";

function useDebounce(callback, delay = 1000) {
    const timeoutId = useRef(null);

    const debouncedFunction = useCallback((...args) => {
        if (timeoutId.current) {
            clearTimeout(timeoutId.current);
        }

        timeoutId.current = setTimeout(() => {
            callback(...args);
        }, delay);
    }, [callback, delay]);

    useEffect(() => {
        return () => {
            if (timeoutId.current) {
                clearTimeout(timeoutId.current);
            }
        };
    }, []);

    return debouncedFunction;
}

export default useDebounce;